import { render, staticRenderFns } from "./LanguageStats.vue?vue&type=template&id=0df1eac6&scoped=true&"
import script from "./LanguageStats.vue?vue&type=script&lang=js&"
export * from "./LanguageStats.vue?vue&type=script&lang=js&"
import style0 from "./LanguageStats.vue?vue&type=style&index=0&id=0df1eac6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0df1eac6",
  null
  
)

export default component.exports